import React from 'react';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import useFilters from '../../../Base/Hooks/useFilters';

export interface AllWorkplacesCalendarFilterValues {
	workplaceIds?: string[];
}

interface Props {
	onFilter: (values: AllWorkplacesCalendarFilterValues) => void;
	customButtons?: React.ReactElement;
}

const AllWorkplacesCalendarFilter: React.FC<Props> = ({
	onFilter,
	customButtons,
}) => {
	const { handleMultiSelectValue } = useFilters();

	const onFilterData = (values: any) => {
		const filter: AllWorkplacesCalendarFilterValues = {
			workplaceIds: handleMultiSelectValue(values.workplaceIds),
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.ALL_WORKPLACES_CALENDAR}
			customButtons={customButtons}>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACES}
				contentWidth={400}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
		</GridFilter>
	);
};

export default AllWorkplacesCalendarFilter;
